import { render, staticRenderFns } from "./PasswordResetCompleteSection.vue?vue&type=template&id=7c797d60&scoped=true"
import script from "./PasswordResetCompleteSection.vue?vue&type=script&lang=ts"
export * from "./PasswordResetCompleteSection.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetCompleteSection.vue?vue&type=style&index=0&id=7c797d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c797d60",
  null
  
)

export default component.exports